import { Box, Grid2 as Grid } from '@mui/material';
import React from 'react';
import CalendarDateSel from './CalendarDateSel';
import SessionSelect from './SessionSelect';
import { commonStyles } from './commonStyles';

export default function PackageDateTimeSelect() {
    return (
        <>
            <Grid size={{ xs: 12, md: 'auto', lg: 6 }}>
                <Box sx={commonStyles.dateSelect}>
                    <CalendarDateSel isPackage={true} />
                </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 'grow', lg: 6 }}>
                <Box sx={commonStyles.timeSelect}>
                    <SessionSelect isPackage={true} />
                </Box>
            </Grid>
        </>
    );
}
